<script>
import appConfig from "@/app.config";
import { authEasyMethods, notificationMethods } from '@/state/helpers';
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header';
import List from "./list.vue";
import Insert from "./insert.vue";
import Edit from "./edit.vue";
import Pago from "./pagamento.vue"
import { http } from '../../../../helpers/easyindustriaapi/config';

export default {
  page: {
    title: 'Contas a pagar',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader,Insert,List,Edit,Pago},
  data() {
    return {
      currentBanco:{},
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Financeiro",
          href: "/",
          active: true,
        },
        {
          text: "Contas a Pagar",
          href: "/financeiro/contasPagar",
          active: true,
        }
      ],
    
      banco: undefined,
      pagas: [],
      titleBody: 'Conta a pagar',
      editando: false,
      inserindo: false,
      pagamento:false,
      clientes:[],
      historicos:[],
      centtros:[],
      resultados:[],
      tiposPagamentos:[]
    }
  },

  created() {
    this.currentUser    = JSON.parse(localStorage.getItem('user')); // para saber qual o usuario atual;
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'));// para saber a emrpessa atual;
    // storage esta no navegador em aplucation;
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    isHide() {
      return (!this.inserindo && !this.editando && !this.pagamento);
    },
  },
  mounted() {
    this.getData();
    this.get_historicos()
    this.get_fornecedores()
    this.get_centros()
    this.get_centros_resultados()
    this.get_tipo_pagamento()
    
   // this.doPost(this.banco)
  },
  methods: {
    ...authEasyMethods,
    ...notificationMethods,
    makeToast(variant = null, message = 'Erro genérico') {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      });
    },
    async get_tipo_pagamento() {
      this.onLoader();
      try {
        let response = await http.get('/tipopagamento?empresa_id=' + this.currentEmpresa.id);
        if (response.status === 200) {
          this.tiposPagamentos = response.data;
          this.offLoader();
        }
      } catch (error) {
        this.makeToast('danger', error.response);
        this.offLoader();
      }
    },
    async get_historicos() {
            try {
                await http.get("/historicopadrao?empresa_id=" + this.currentEmpresa.id)
                    .then(res => {
                        this.historicos = res.data ? res.data : null;
                        //console.log(this.historicos)
                    })

            } catch (error) {
                // this.offLoader();
                if (error.response && error.response.status === 403) {
                    this.error('Usuário não tem permissão!');
                }
            }
        },
        async get_fornecedores() {
            try {
                await http.get("/pessoa?empresa_id=" + this.currentEmpresa.id)
                    .then(res => {
                        this.clientes = res.data ? res.data : null;
                       // console.log(this.fornecedores)
                    })

            } catch (error) {
                // this.offLoader();
                if (error.response && error.response.status === 403) {
                    this.error('Usuário não tem permissão!');
                }
            }
        },
    changeHomeTitle(newTitle) {
      this.titleBody = newTitle;
    },
    onLoader() {
      if (document.getElementById("preloader").style.display === "none")
      {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      }
    },
    offLoader() {
      if (document.getElementById("preloader").style.display === "block")
      {
        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      }
    },
    async getData() {
      this.onLoader();

      try {
        let response = await http.get('/pagas?empresa_id='+this.currentEmpresa.id);
        //let response = await http.get('http://localhost:8080/api/banco?empresa_id=1');
       // console.log(response1.data);
        if (response.status === 200) {
          this.pagas = response.data;
          //console.log(this.pagas)
          setTimeout(() => {
            this.offLoader();
          }, 2000);// tempo para carregar a tela;
        } else {
          this.pagas = []; // zera o array;
          this.makeToast('danger', 'Erro ao carregar lista');
          this.offLoader();
        }
      } catch (error) {
        this.offLoader();

        if (error.response) {
          if (error.response.status === 404) {
            this.makeToast('danger', 'Destino URL não encontrado!');
          } else {
            this.makeToast('danger', error.response);
          }
        }
      }
    },
    setBanco(banco) {
      this.currentBanco = banco;
    },
    insert() {
      this.inserindo = !this.inserindo;
    },
    edit(oldpago) {
      this.setBanco(oldpago);
      this.editando = !this.editando;
    },
    pagando(oldConta){
       ///console.log(oldConta)
       this.setBanco(oldConta)
       this.pagamento = !this.pagamento
       console.log("esotu em pagando")
    },
    async doPost(pagos) {
      pagos.empresa_id = this.currentEmpresa.id;
      pagos.user_id = this.currentUser.id;
      //console.log(pagos);
      this.onLoader();
      try {
        let response = await http.post('/pagas?empresa_id='+this.currentEmpresa.id,pagos);
        if (response) {
          this.offLoader();
          if (response.status === 200) {
            this.getData();
            this.inserindo = false;
            this.makeToast('success', 'Registro incluído');
          }
        }
      } catch (error) {
        this.offLoader();
        if (error.response) {
          if (error.response.status === 404) {
            this.makeToast('danger', 'Destino URL não encontrado!');
          } else {
            this.makeToast('danger', error);
          }
        }
      } 
    },
    async doPut(pagas) {
      /// console.log("estrou no put para atualizar")
       console.log(pagas.pago)
      this.onLoader();
      console.log(pagas)
      try {
        let response = await http.put('/pagas/'+pagas.id+'?empresa_id='+this.currentEmpresa.id, pagas);
        if (response) {
          this.offLoader();
          if (response.status === 200) {
            this.makeToast('success', 'Registro alterado');
            this.getData();
            this.editando = false;
            this.pagamento = false;
          }
        }
      } catch (error) {
        this.offLoader();
        if (error.response) {
          if (error.response.status === 404) {
            this.makeToast('danger', 'Destino URL não encontrado!');
          } else {
            this.makeToast('danger', error);
          }
        }
      }
    },
    async doDelete(pagas) {
      this.onLoader();

      try {
        let response = await http.delete('/pagas/'+pagas.id+'?empresa_id='+this.currentEmpresa.id, pagas);
        if (response) {
          
          if (response.status === 200) {
            this.getData();
            this.offLoader();
            this.makeToast('warning', 'Registro excluído');
          }
        }
      } catch (error) {
        this.offLoader();
        if (error.response) {
          if (error.response.status === 404) {
            this.makeToast('danger', 'Destino URL não encontrado!');
          } else {
            this.makeToast('danger', error);
          }
        }
      }
    },
    async get_centros() {
      try {
        await http.get("/centrocusto?empresa_id=" + this.currentEmpresa.id)
          .then(res => {
            this.centtros = res.data ? res.data : null;
            // console.log(this.centtros)
          })

      } catch (error) {
        // this.offLoader();
        if (error.response && error.response.status === 403) {
          this.error('Usuário não tem permissão!');
        }
      }
    },
    async get_centros_resultados() {
      try {
        await http.get("/centroresultado?empresa_id=" + this.currentEmpresa.id)
          .then(res => {
            this.resultados = res.data ? res.data : null;
            // console.log(this.centtros)
          })

      } catch (error) {
        // this.offLoader();
        if (error.response && error.response.status === 403) {
          this.error('Usuário não tem permissão!');
        }
      }
    },
    back() {
      this.inserindo = false;
      this.editando  = false;
      this.pagamento = false
      this.titleBody = 'Conta a Pagar';
    },
  },
}
</script>
<template>
<Layout>
  <PageHeader :title="titleBody" :items="items" />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6 text-md-right">
              <button @click="insert()" v-if="isHide" type="button" class="btn btn-success">+ Incluir Conta </button>
              <button @click="back()" v-if="!isHide" class="btn btn-secondary">Voltar</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div v-if="!isHide" class="card-body">
           <Edit v-if="editando"
           :empresa="currentEmpresa"
           :oldpago="currentBanco"
           @newTitle="changeHomeTitle"
           @doPut="doPut"
           :tiposPagamentos="tiposPagamentos" :resultados="resultados" :centtros="centtros" :clientes="clientes" :historicos="historicos"
          />
           <Pago v-if="pagamento"
           :empresa="currentEmpresa"
           :oldpago="currentBanco"
           @newTitle="changeHomeTitle"
           @doPut="doPut"
           @back="back"
           :abre_modal="pagamento"
           
           
          />
          <Insert v-if="inserindo" :tiposPagamentos="tiposPagamentos" :resultados="resultados" :centtros="centtros" :clientes="clientes" :historicos="historicos"
           @newTitle="changeHomeTitle"
           @doPost="doPost"
          />
        </div>
        <List
         v-if="isHide"
         :currentEmpresa="currentEmpresa"
         :listBancos="pagas"
         :hide="isHide"
         @edit="edit"
         @newTitle="changeHomeTitle"
         @setBanco="setBanco"
         @doDelete="doDelete"
         @pagando="pagando"
        />
      </div>
    </div>
  </div>
</Layout>
</template>